<div class="rel form__field-invalid" aria-live="polite">
  @if (duplicateCount > 0) {
    <div class="form__invalid-msg ib rel" [@dfSlideFadeInLeft]>
      <df-icon size="small" icon="arrow-down-right"></df-icon>
      <span class="guts-p-l-half">{{ i18n.duplicatesFound }}</span>
      <span>{{ i18n.decision }}</span>
      <button
        (click)="viewDuplicates.emit()"
        type="button"
        class="link"
        data-dgat="checkDuplicateInputs-f6a"
      >
        {{ i18n.viewDuplicates }}
      </button>
    </div>
  }
</div>
